<template>
  <div class="link-cell">
    <span class="link-cell__target">{{ row[headCell.value] }}</span>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import { decoratorProps } from '@/mixin/props'

const props = defineProps({
  ...decoratorProps.props
})

</script>

<style scoped lang="scss">
@import "~@/styles/_variables.scss";
</style>
